import { CopyIcon, cn, DeleteIcon, Text } from '@viapeople/components'
import { useFormComponentWrapper } from '../../hooks/useFormElementWrapper'
import { useFormBuilderStore } from '../../store'
import { DeleteComponentDialog } from '../DeleteComponentDialog'
import { BaseFormComponentWrapper } from './BaseFormElementWrapper'
import type { FormComponentWrapperProps } from './types'

export const RepeatableFormComponentWrapper = ({ component, index, containerId }: FormComponentWrapperProps) => {
	const wrapperProps = useFormComponentWrapper(component, index, containerId)
	const {
		handleDelete,
		handleDuplicate,
		handleConfirmDelete,
		handleCancelDelete,
		isSelected,
		isDeleteDialogOpen,
		dependentComponents,
		componentLabel,
	} = wrapperProps
	const { label } = component.custom as {
		label: string
	}
	const getComponentDefinition = useFormBuilderStore((state) => state.getComponentDefinition)

	const componentDefinition = getComponentDefinition(component.name)

	return (
		<>
			<BaseFormComponentWrapper component={component} index={index} wrapperProps={wrapperProps}>
				<div className='flex flex-col group/container'>
					<div
						className={cn(
							'bg-neutral-50',
							'flex gap-2 px-5 pt-2 pb-[9px] mb-[-1px] self-start border-neutral-200 border-t border-x rounded-t-md z-10 items-center cursor-pointer',
							isSelected ? 'border-primary-600' : 'border-neutral-200 group-hover/container:border-neutral-300',
						)}>
						<Text variant='xsmall' weight='semibold' className='mr-2 capitalize max-w-[200px] truncate'>
							{componentDefinition?.displayName}
							{label && `: ${label}`}
						</Text>
						<button type='button' onClick={handleDuplicate} title='Duplicate' className='cursor-pointer'>
							<CopyIcon size={20} className='fill-neutral-500 hover:fill-primary-600' />
						</button>
						<button type='button' onClick={handleDelete} title='Delete' className='cursor-pointer'>
							<DeleteIcon size={20} className='fill-neutral-500 hover:fill-error-600' />
						</button>
					</div>
					<div
						className={cn(
							'bg-neutral-50',
							'relative w-full border rounded-md cursor-pointer rounded-tl-none',
							isSelected ? 'border-primary-600' : 'border-neutral-200 group-hover/container:border-neutral-300',
						)}>
						{(() => {
							const componentDef = getComponentDefinition(component.name)
							const ComponentRenderer = componentDef?.component
							return ComponentRenderer ? <ComponentRenderer component={component} /> : null
						})()}
					</div>
				</div>
			</BaseFormComponentWrapper>
			<DeleteComponentDialog
				isOpen={isDeleteDialogOpen}
				onClose={handleCancelDelete}
				onConfirm={handleConfirmDelete}
				componentLabel={componentLabel}
				dependentComponents={dependentComponents}
			/>
		</>
	)
}
